module.exports = __webpack_public_path__ + "img/band_of_elvenskin.85a1bb09.png";